<template>
  <div class="home">
    <Hero
        :nomeSistema="nomeSistema"
        :textoBanner="textoBanner"
        :linkCadastro="linkCadastro"
        :bannerTopo="bannerTopo"

        :permiteRedefinicaoEmail="permiteRedefinicaoEmail"

        :habilitadoCardEntrar="habilitadoCardEntrar"
        :tituloCardEntrar="tituloCardEntrar"
        :textoCardEntrar="textoCardEntrar"
        :botaoCardEntrar="botaoCardEntrar"

        :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
        :tituloCardPrimeiroAcesso="tituloCardPrimeiroAcesso"
        :textoCardPrimeiroAcesso="textoCardPrimeiroAcesso"
        :botaoCardPrimeiroAcesso="botaoCardPrimeiroAcesso"

        :habilitadoCardCadastro="habilitadoCardCadastro"
        :tituloCardCadastro="tituloCardCadastro"
        :textoCardCadastro="textoCardCadastro"
        :botaoCardCadastro="botaoCardCadastro"

        :tituloCardPasso1="tituloCardPasso1"
        :textoCardPasso1="textoCardPasso1"

        :tituloCardPasso2="tituloCardPasso2"
        :textoCardPasso2="textoCardPasso2"

        :tituloCardPasso3="tituloCardPasso3"
        :textoCardPasso3="textoCardPasso3"

        :tituloCardPasso4="tituloCardPasso4"
        :textoCardPasso4="textoCardPasso4"

        :canaisAtendimento="canaisAtendimento"
        :habilitadoLinkFaleConosco="habilitadoLinkFaleConosco"

        :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
        :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"

        :urlCadastroPessoaFisica="urlCadastroPessoaFisica"
        :urlCadastroPessoaJuridica="urlCadastroPessoaJuridica"
    />

    <v-dialog width="50vw" v-model="mostraComunicado">
      <img :src="`data:image/png;base64,${imagemComunicado}`" alt/>
    </v-dialog>

    <section>
      <v-layout column wrap class="my-12" align-center>
        <v-flex xs12 sm4 class="my-4">
          <div class="text-center">
            <h2 class="display-2">{{ messageTituloNotaFiscalEletronica }}</h2>
            <br/>
            <p class="subheading grey--text px-10">{{ sobreSistema }}</p>
          </div>
        </v-flex>
        <v-flex xs12 sm4>
          <v-container grid-list-xl>
            <div class="text-center">
              <h2 class="display-1 my-3 font-weight-thin">
                Veja como é fácil fazer parte desta inovação
              </h2>
            </div>
            <v-divider></v-divider>
            <v-layout wrap justify-center>
              <v-flex xs12 md3 v-if="habilitadoCardPasso1">
                <v-card>
                  <v-img
                      class="white--text align-end"
                      src="@/assets/foto1.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">{{ tituloCardPasso1 }}</p>
                    <span class="caption">{{ textoCardPasso1 }}</span>
                  </v-card-text>
<!--                  <v-card-actions>-->
<!--                    <v-btn text block small outlined :href="linkCadastro">-->
<!--                      Cadastrar-->
<!--                    </v-btn>-->
<!--                  </v-card-actions>-->
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-if="habilitadoCardPasso2">
                <v-card>
                  <v-img
                      class="white--text align-end"
                      src="@/assets/foto4.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">{{ tituloCardPasso2 }}</p>
                    <span class="caption">{{ textoCardPasso2 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-if="habilitadoCardPasso3">
                <v-card>
                  <v-img
                      class="white--text align-end"
                      src="@/assets/foto5.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">{{ tituloCardPasso3 }}</p>
                    <span class="caption">{{ textoCardPasso3 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-if="habilitadoCardPasso4">
                <v-card>
                  <v-img
                      class="white--text align-end"
                      src="@/assets/foto6.jpg"
                  />
                  <v-card-text>
                    <p class="subtitle-1 black--text">{{ tituloCardPasso4 }}</p>
                    <span class="caption">{{ textoCardPasso4 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/Hero.vue";
import EventService from "@/services/EventService";

export default {
  props: {
    bannerTopo: {
      type: String,
    },
    nomeSistema: {
      type: String,
    },
    textoBanner: {
      type: String,
    },
    sobreSistema: {
      type: String,
    },
    linkCadastro: {
      type: String,
    },

    permiteRedefinicaoEmail: {
      type: Boolean,
    },

    habilitadoCardEntrar: {
      type: Boolean,
    },
    tituloCardEntrar: {
      type: String,
    },
    textoCardEntrar: {
      type: String,
    },
    botaoCardEntrar: {
      type: String,
    },

    habilitadoCardPrimeiroAcesso: {
      type: Boolean,
    },
    tituloCardPrimeiroAcesso: {
      type: String,
    },
    textoCardPrimeiroAcesso: {
      type: String,
    },
    botaoCardPrimeiroAcesso: {
      type: String,
    },

    habilitadoCardCadastro: {
      type: Boolean,
    },
    tituloCardCadastro: {
      type: String,
    },
    textoCardCadastro: {
      type: String,
    },
    botaoCardCadastro: {
      type: String,
    },

    habilitadoCardPasso1: {
      type: Boolean,
    },

    tituloCardPasso1: {
      type: String,
    },
    textoCardPasso1: {
      type: String,
    },

    habilitadoCardPasso2: {
      type: Boolean,
    },
    tituloCardPasso2: {
      type: String,
    },
    textoCardPasso2: {
      type: String,
    },

    habilitadoCardPasso3: {
      type: Boolean,
    },

    tituloCardPasso3: {
      type: String,
    },
    textoCardPasso3: {
      type: String,
    },

    habilitadoCardPasso4: {
      type: Boolean,
    },

    tituloCardPasso4: {
      type: String,
    },
    textoCardPasso4: {
      type: String,
    },

    canaisAtendimento: {
      type: String,
    },

    habilitadoLinkFaleConosco: {
      type: Boolean,
    },

    habilitadoAutenticacaoPessoaFisica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaJuridica: {
      type: Boolean,
    },
    urlCadastroPessoaFisica: {
      type: String,
    },
    urlCadastroPessoaJuridica: {
      type: String,
    }
  },
  data() {
    return {
      imagemComunicado: null,
      mostraComunicado: false,
      messageTituloNotaFiscalEletronica: "",
      // messageInovacaoCardCadastro: "",
      // messageInovacaoCardAcessoSistema: "",
      // labelInovacaoEmissao: "",
      // messageInovacaoCardEmissao: "",
      // messageInovacaoCardGuiaRecolhimento: "",
    }
  },
  components: {
    Hero,
  },
  created() {
    this.popupComunicado()

    EventService
        .getBundle("message.portalInicialTituloNotaFiscalEletronica")
        .then(res => this.messageTituloNotaFiscalEletronica = res.data)

    // EventService
    //     .getBundle("message.portalInovacaoCardCadastro")
    //     .then(res => this.messageInovacaoCardCadastro = res.data)

    // EventService
    //     .getBundle("message.portalInovacaoCardAcessoSistema")
    //     .then(res => this.messageInovacaoCardAcessoSistema = res.data)
    //
    // EventService
    //     .getBundle("label.portalInovacaoEmissao")
    //     .then(res => this.labelInovacaoEmissao = res.data)
    //
    // EventService
    //     .getBundle("message.portalInovacaoCardEmissao")
    //     .then(res => this.messageInovacaoCardEmissao = res.data)
    //
    // EventService
    //     .getBundle("message.portalInovacaoCardGuiaRecolhimento")
    //     .then(res => this.messageInovacaoCardGuiaRecolhimento = res.data)
  },
  mounted() {
    if (window.location.href.includes('notajoseense.sjc.sp.gov.br')) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-G28PN6X7QR';
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-G28PN6X7QR');
    `;
      document.head.appendChild(script2);
    }
  },
  methods: {
    popupComunicado() {
      this.$httpNF(`popup-comunicado`).then(res => {
            this.imagemComunicado = res.data.imagem;
            this.mostraComunicado = res.data.mostraComunicado;
          }
      )
    },
  },
  name: "Home",
};
</script>